var React = require('react');

function French (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.64 218.393c0-1.853 14.891 10.205 37.309 11.055 22.416 2.352 52.355-6.506 82.452-15.427 30.097-8.899 60.348-17.89 83.388-15.56 23.04.854 38.868 13.028 40.116 12.4V38.92c-1.235.8-16.906-11.481-39.797-12.397-22.89-2.399-53 6.57-83.108 15.507-30.11 8.93-60.217 17.857-83.108 15.439-22.89-.933-38.562-13.211-39.797-12.41V217c1.274.723 2.544 1.393 2.544 1.392z","fill":"white","key":0}),React.createElement("path",{"d":"M87.804 56.179c-26.721 6.023-53.442 7-80.163-7.138v166.846c26.721 14.137 53.442 13.16 80.163 7.138V56.179z","fill":"#002654","key":1}),React.createElement("path",{"d":"M168.2 199.825c26.72-6.025 53.44-7 80.16 7.137V40.117c-26.72-14.138-53.44-13.162-80.16-7.14v166.848z","fill":"#ce1126","key":2})]);
}

French.defaultProps = {"width":"64","height":"64","viewBox":"0 0 256 256"};

module.exports = French;

French.default = French;
